import * as React from "react";
// @ts-ignore
import logo from "../../Assets/Images/LogoParho.webp";
// @ts-ignore
import logo_white from "../../Assets/Images/seekhologo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// @ts-ignore
import {
  solid,
  regular,
  brands,
} from "@fortawesome/fontawesome-svg-core/import.macro";

import { useEffect, useState, useRef, useContext } from "react";
import { faFacebookF, faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import { TabView, TabPanel } from "primereact/tabview";

import swal from "sweetalert";
// @ts-ignore
import searchService from "../../screens/searchService";
import {
  useLocation,
  useNavigate,
  Link,
  useSearchParams,
} from "react-router-dom";
import { unsubscrib } from "../../services/AuthService";
import {
  getCategories,
  getCoursesByCategory,
  getGrades,
} from "../../services/coursesService";
import { getQuranClass } from "../../services/liveQuranService";
import { getSatCourses } from "../../services/SatCourseService";
// @ts-ignore
import ApiNames from "../../constants/ApiNames";
import tagManagerEvents from "../../utils/GoogleTagManager";
// @ts-ignore
import UrlNames from "../../constants/UrlNames";
// @ts-ignore
import UserContext from "../../utils/UserContext";
import {
  clearAllCookies,
  NavigateToLanding,
  getDataFromCookies,
  getErrorDataCase,
} from "../../utils/CommonFunction";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import UnsubscribePopup from "../UnsubscribePopup";
import AlertModal from "../AlertPopup";
import { Config } from "../../constants/Config";
import { unsubscribeGuestUserService } from "../../services/UserService";
import FailurePopUp from "./FailurePopUp";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

// @ts-ignore
const $ = require("jquery");
export interface HeaderProps {
  loader?: boolean;
  token?: string;
  loaderStatus: (status: boolean) => void;
  utm_source?: string;
}

let recaptchaToken = "";

export default function Header(props: HeaderProps) {
  const navigate = useNavigate();
  const [stickyClass, setStickyClass] = useState("");
  const [window_height, setwindow_height] = useState(0);
  const [categories, setCategories] = useState<any>(null);

  const [grades, setgrades] = useState<any>(null);
  const _location = useLocation();

  const [activeIndex, setActiveIndex] = useState(0);
  //for search
  const [enteredInputValue, setEnteredInputValue] = useState("");
  const inputValue = useRef<any>();
  const [searchArray, setSearchArray] = useState<any>(null);
  const [searchData, setSearchData] = useState<any>(null);
  const [hideSearchBar, onHideSearchBAr] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [checkClass, setCheckClass] = useState(false);
  const [currentClass, setCurrentClass] = useState("");
  const [quranClassData, setQuranClassData] = useState<any>(null);
  const [checkWidth, setCheckWidth] = useState(0);
  const { satCourseData, setSatCourseData, subscriberId } =
    useContext<any>(UserContext);
  const { cookieMsisdn } = getDataFromCookies();


  const [showUnsub, setShowUnsub] = useState<
    "none" | "fail" | "success" | "confirm" | "unsub"
  >("none");
  const [isLoading, setIsLoading] = useState(false);
  const [msisdn, setmsisdn] = useState("");
  const [error, setError] = useState("Something went wrong, please try again");

  const utm_source = searchParams.get("utm_source")
    ? searchParams.get("utm_source")
    : "";

  const unifiedSearch = async (token: string) => {
    const data = await searchService.getSearchData(token);

    if (data.response) {
      onHideSearchBAr(true);
    }

    setSearchData(
      data.response.filter((item: any) => item.type !== 0 && item.type !== 1),
    );
  };

  const filterSearch = (text: string) => {
    if (text !== "" && text && searchData && searchData.length > 0) {
      const res = searchData.filter((items: any) => {
        if (
          items.title?.toLowerCase().includes(text.toLowerCase()) ||
          (items.description?.toLowerCase().includes(text.toLowerCase()) &&
            items.type !== 0 &&
            items.type !== 1)
        ) {
          return true;
        }
        return false;
      });
      setSearchArray(res);
    }
  };

  useEffect(() => {
    if (enteredInputValue.length > 2) {
      filterSearch(enteredInputValue);
    } else {
      setSearchArray([]);
    }
  }, [enteredInputValue]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      $("body").on("click", function (e: any) {
        let target = e.target instanceof HTMLInputElement;
        var course_menu = $("#course_menu");
        course_menu.removeClass("show");
        if ($(e.target).hasClass("menu_overlay")) {
          $(".menu_overlay").addClass("d-none");
          $(".navbar-collapse").removeClass("show");
        }
        $("#navbarDropdownMenuLink").removeClass("active");
        if (target === false) {
          $("#searchBox").removeClass("d-block");
          $("#searchBox").addClass("d-none");
        } else {
          if (enteredInputValue && target === true) {
            $("#searchBox").removeClass("d-none");
            $("#searchBox").addClass("d-block");
          }
        }
      });
      if (
        (typeof window !== "undefined" &&
          _location.pathname.includes("/courses")) ||
        _location.pathname.includes(UrlNames.satCourse) ||
        _location.pathname.includes("/course_detail") ||
        _location.pathname.includes(UrlNames.chapters) ||
        _location.pathname.includes(UrlNames.content) ||
        _location.pathname.includes(UrlNames.bookMark)
      ) {
        setStickyClass("position-fixed");
      } else {
        setStickyClass("");
      }
      $(".nav-link ").on("click", function (this: any) {
        if ($(this).text() !== "COURSES") {
          var course_menu = $("#course_menu");
          $("#navbarDropdownMenuLink").removeClass("active");
          course_menu.removeClass("show");
        }
      });
      window.addEventListener("scroll", stickNavbar);

      return () => window.removeEventListener("scroll", stickNavbar);
    }
  }, []);

  useEffect(() => {
    if (props.token !== null && props.token !== undefined) {
      _getCat();
      unifiedSearch(props.token);
      getClass();
    }
  }, [props.token]);

  useEffect(() => {
    if (satCourseData.length === 0) CoursesApiCall();
  }, []);

  useEffect(() => {
    setCheckWidth(window.innerWidth);
  }, [checkWidth]);

  var ls: any[] = [];
  const _getCat = async () => {
    try {
      const data = await getCategories(props.token);

      data.response.map(async (item: any) => {
        const course_data = await getCoursesByCategory(
          item.id,
          null,
          props.token,
        );
        course_data.response.sort((a: any, b: any) =>
          a.title.length < b.title.length ? -1 : 1,
        );
        item["courses"] = course_data.response.map((item: any) => {
          return item;
        });
        return item;
      });

      setCategories(data.response);
      const sub = await getGrades(props.token);
      sub.response.sort((a: any, b: any) =>
        a.title.length < b.title.length ? -1 : 1,
      );

      setgrades(sub.response);
      props.loaderStatus(true);
    } catch {
      props.loaderStatus(true);
    }
  };

  const handleChange = (event: any, newValue: any) => {
    if (newValue.index === 1) {
      tagManagerEvents("Vocational_Trainings", utm_source);
    } else if (newValue.index === 2) {
      tagManagerEvents("Executive_Trainings", utm_source);
    } else if (newValue.index === 3) {
      tagManagerEvents("Language_learning", utm_source);
    } else {
      tagManagerEvents("Students_Grades", utm_source);
    }
    setActiveIndex(newValue.index);
    event.stopPropagation();
  };

  const showDropdown = (e: any) => {
    if (typeof window !== "undefined") {
      var course_menu = $("#course_menu");
      tagManagerEvents("Students_Grades", utm_source);
      if (window.innerWidth > 991) {
        course_menu.addClass("show");
        $("#searchBox").removeClass("d-block");
        $("#searchBox").addClass("d-none");
        $("#navbarDropdownMenuLink").addClass("active");
        try {
          e.preventDefault();
          e.stopPropagation();
        } catch { }
      }
    }
  };

  const hideDropDown = (e: any) => {
    var course_menu = $("#course_menu");

    if (window.innerWidth > 991) {
      if (course_menu.hasClass("show")) {
        course_menu.removeClass("show");

        let locationName = window.location.pathname;

        if (locationName === "/courses") {
          $("#navbarDropdownMenuLink").addClass("active");
        } else {
          $("#navbarDropdownMenuLink").removeClass("active");
        }
      }
      try {
        e.preventDefault();
        e.stopPropagation();
      } catch { }
    }
  };

  const stickNavbar = () => {
    if (typeof window !== "undefined") {
      let windowHeight = window.scrollY;

      setwindow_height(windowHeight);
      if (windowHeight > 10) {
        setStickyClass("sticky-nav");
      } else {
        setStickyClass("");
        if (
          (typeof window !== "undefined" &&
            window.location.pathname.includes("/courses")) ||
          window.location.pathname.includes("/course_detail") ||
          window.location.pathname.includes(UrlNames.satCourse) ||
          window.location.pathname.includes(UrlNames.chapters) ||
          window.location.pathname.includes(UrlNames.topics) ||
          window.location.pathname.includes(UrlNames.content) ||
          window.location.pathname.includes(UrlNames.bookMark)
        ) {
          setStickyClass("position-fixed");
        } else {
          setStickyClass("");
        }
      }
    }
  };

  const unSub = async () => {
    try {
      setIsLoading(true);
      const subId = cookieMsisdn;
      const data = await unsubscrib(subId, props.token);
      if (data.status === 200) {
        tagManagerEvents("unsubscribe", utm_source);
        setShowUnsub("none");
        logout();
        clearAllCookies();
      } else {
        setShowUnsub("none");
        swal("Failed to unsubscribe please try again later.");
      }
    } catch (error) {
      console.log("unsub error", error);
      setShowUnsub("none");
      swal("Failed to unsubscribe please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleUnsubscribeClick = () => {
    if (cookieMsisdn) {
      setShowUnsub("confirm");
    } else {
      setShowUnsub("unsub");
    }
  };

  const unsubGuestUser = React.useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await unsubscribeGuestUserService(
        msisdn,
        recaptchaToken,
      );
      const responseMsg = response.result.toLowerCase();
      if (responseMsg.includes("success")) {
        setShowUnsub("success");
      }
    } catch (error) {
      console.log("Unsubscribe::", error);
      const errMsg = getErrorDataCase(error);
      if (errMsg.toLowerCase().includes("subscriber not found")) {
        setError("You don't have an active subscription.");
      } else {
        setError(errMsg || "Unable to unsubscribe. Please try again.");
      }
      setShowUnsub("fail");
    } finally {
      setmsisdn("");
      setIsLoading(false);
    }
  }, [msisdn]);

  const onChange = React.useCallback(
    (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
      >,
    ) => {
      const userInput = e.target.value;
      if (
        userInput === "" ||
        (userInput.length <= 10 && /^3\d{0,9}$/.test(userInput))
      ) {
        setmsisdn(userInput);
      }
    },
    [],
  );

  const logout = () => {
    clearAllCookies();
    setStickyClass("");
    let url = window.location.origin;
    url = `${url}/landing`;
    window.location.replace(url);
  };

  const showMenu = () => {
    $(".menu_overlay").removeClass("d-none");
  };

  const hideMenu = () => {
    $(".menu_overlay").addClass("d-none");
  };

  const resize = () => {
    if (window.innerWidth > 992 && typeof window !== "undefined") {
      $(".menu_overlay").addClass("d-none");
      $(".navbar-collapse").removeClass("show");
    }
  };

  if (typeof window !== "undefined") {
    window.addEventListener("resize", resize);
  }

  const handleCoursesEvent = (id?: number) => {
    if (id === 9) {
      tagManagerEvents("Vocational_Trainings", utm_source);
    } else if (id === 10) {
      tagManagerEvents("Executive_Trainings", utm_source);
    } else if (id === 11) {
      tagManagerEvents("Language_learning", utm_source);
    } else {
      tagManagerEvents("Students_Grades", utm_source);
    }
  };

  const handleLanguageEvent = (course_name: string) => {
    tagManagerEvents(`${course_name}`, utm_source);
  };

  const getClass = async () => {
    try {
      let response = await getQuranClass(props.token);
      if (response.status === 200) {
        setQuranClassData(response.response);
        if (response.response.live !== null) {
          setCheckClass(true);
        } else {
          setCheckClass(false);
        }
        if (response.response.previous.length > 0) {
          // setPreviousClass(response.response.previous);
        }
      }
    } catch (error) {
      console.log("getClass", error);
    }
  };

  const HandleEnterButton = (event: any) => {
    if (event.key === "Enter") {
      // tagManagerEvents("search", utm_source);
    }
  };

  const CoursesApiCall = async () => {
    let token = props.token;
    const id = subscriberId ? subscriberId : "9";

    try {
      props.loaderStatus(false);
      let response = await getSatCourses(id, token);
      if (response.status === 200) {
        setSatCourseData(response.response);
        props.loaderStatus(true);
      } else {
        props.loaderStatus(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const NavigateLanding = () => {
    NavigateToLanding();
  };

  return (
    <>
      {!props.loader ? (
        <div></div>
      ) : (
        <>
          <div className="menu_overlay d-none"></div>
          <div className="w-100 bg-red py-2 top-bar">
            <div className="container-xxl d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <a
                  href="https://www.facebook.com/profile.php?id=61589560892805"
                  target="_blank"
                  rel="noreferrer"
                  className=" me-2 text-white  small "
                >
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a
                  href="https://www.instagram.com/sekho.digital/"
                  target="_blank"
                  rel="noreferrer"
                  className=" text-white  pe-2  small"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a
                  href="https://wa.me/923232920572"
                  target="_blank"
                  rel="noreferrer"
                  className=" text-white  pe-2  small"
                >
                  <FontAwesomeIcon icon={faWhatsapp} />
                </a>
                <a
                  href="mailto:support@celsius.cc"
                  rel="noreferrer"
                  className=" text-white  pe-2  small"
                >
                  <FontAwesomeIcon icon={faEnvelope} />
                </a>
              </div>
              <div>
                <div className="btn-group">
                  {typeof window !== "undefined" && cookieMsisdn ? (
                    <>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                        }}
                        className="dropdown-toggle text-white small"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <FontAwesomeIcon icon={solid("user")} />
                        <small> Logged in as</small>
                      </a>
                      <ul className="dropdown-menu rounded mt-1 bg-red">
                        <li>
                          <a
                            className="dropdown-item text-white border-bottom border-red small"
                            href="#"
                          >
                            <FontAwesomeIcon icon={solid("user-circle")} />
                            <span className="ms-2">
                              {typeof window !== "undefined" && cookieMsisdn}
                            </span>
                          </a>
                        </li>
                        {/* <li>
                          <a
                            className="dropdown-item text-white border-bottom border-red small"
                            onClick={unSub}
                          >
                            {" "}
                            <FontAwesomeIcon icon={solid("user-minus")} />
                            <span className="ms-2 cursor-pointer">
                              Unsubscribe
                            </span>
                          </a>
                        </li> */}
                        <li>
                          <a
                            className="dropdown-item text-white small"
                            onClick={logout}
                          >
                            {" "}
                            <FontAwesomeIcon
                              icon={solid("right-from-bracket")}
                            />
                            <span className="ms-2 cursor-pointer">Logout</span>
                          </a>
                        </li>
                      </ul>
                    </>
                  ) : (
                    <>
                      {/* <div
                        className="ms-3 text-white  small cursor-pointer"
                        onClick={() => setShowUnsub("unsub")}
                      >
                        <FontAwesomeIcon icon={solid("user")} />
                      </div> */}
                      <button
                        className="ms-3 text-white  small "
                        style={{
                          backgroundColor: "transparent",
                          border: "transparent",
                        }}
                        onClick={() => {
                          NavigateLanding();
                        }}
                      >
                        Subscribe
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className={`w-100 mt-3 nav_bar ${stickyClass}`}>
            <div className="container-xxl">
              <nav
                className={`navbar navbar-expand-lg navbar-light ${(typeof window !== "undefined" &&
                  (_location.pathname.includes("/courses") ||
                    _location.pathname.includes("/course_detail") ||
                    _location.pathname.includes(UrlNames.satCourse))) ||
                  _location.pathname.includes(UrlNames.chapters) ||
                  _location.pathname.includes(UrlNames.topics) ||
                  _location.pathname.includes(UrlNames.content) ||
                  _location.pathname.includes(UrlNames.bookMark)
                  ? "nav-link-white"
                  : ""
                  } `}
              >
                <Link
                  to="/home"
                  onClick={() => {
                    setStickyClass("");
                  }}
                >
                  {" "}
                  {_location.pathname === `${UrlNames.satCourse}` ||
                    _location.pathname === `${UrlNames.chapters}` ||
                    _location.pathname === `${UrlNames.topics}` ||
                    _location.pathname === `${UrlNames.content}` ||
                    _location.pathname === `${UrlNames.bookMark}` ? (
                    <>
                      <img
                        src={
                          checkWidth <= 1024 || window_height > 10
                            ? logo
                            : logo_white
                        }
                        className="logo"
                        alt="Logo"
                      />
                    </>
                  ) : (
                    <>
                      <img
                        src={
                          (typeof window !== "undefined" &&
                            !_location.pathname.includes("/courses") &&
                            !_location.pathname.includes("/course_detail")) ||
                            window_height > 10
                            ? logo
                            : logo_white
                        }
                        className="logo"
                        alt="Logo"
                      />
                    </>
                  )}
                </Link>

                <div className="d-flex align-items-center d-lg-none">
                  <button
                    type="button"
                    className="header_unsub_btn me-2"
                    onClick={handleUnsubscribeClick}
                  >
                    Unsubscribe
                  </button>
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={showMenu}
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <FontAwesomeIcon className="text-grey" icon={solid("bars")} />
                  </button>
                </div>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <div className="w-100 d-flex my-3 p-3 px-5 justify-content-between d-lg-none  align-items-center">
                    <Link to="/home">
                      {" "}
                      <img src={logo} className="logo" alt="Logo" />
                    </Link>
                    <button
                      className="navbar-toggler"
                      type="button"
                      onClick={hideMenu}
                      data-bs-toggle="collapse"
                      data-bs-target="#navbarSupportedContent"
                      aria-controls="navbarSupportedContent"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <FontAwesomeIcon
                        className="text-grey"
                        icon={solid("times")}
                      />
                    </button>
                  </div>
                  {hideSearchBar === false ? null : (
                    <div className="d-md-none d-lg-flex search ms-5 position-relative ms-md-auto  input-group  ms-md-4">
                      <span className="input-group-text cursor-pointer bg-transparent br-left-15 border-right-0">
                        <FontAwesomeIcon
                          className="text-grey "
                          icon={solid("search")}
                        />
                      </span>
                      <input
                        type="search"
                        className="form-control bg-transparent br-right-15 small py-2 border_gray"
                        placeholder="What do you want to learn?"
                        value={enteredInputValue}
                        onChange={(event) => {
                          setEnteredInputValue(event.target.value);
                        }}
                        onClick={() => {
                          tagManagerEvents("search", utm_source);
                        }}
                        onKeyDown={(event) => {
                          HandleEnterButton(event);
                        }}
                      />

                      {enteredInputValue && searchArray.length > 0 && (
                        <div
                          id="searchBox"
                          className={`${enteredInputValue ? "d-block" : "d-none"
                            } w-100 shadow-sm rounded bg-white border-top border-bottom`}
                          style={{
                            position: "absolute",
                            top: 40,
                            overflow: "auto",
                            height: 300,

                            zIndex: 9999,
                          }}
                        >
                          {searchArray &&
                            (searchArray || []).map(
                              (data: any, index: number) => {
                                return (
                                  <div
                                    className="list-group w-1000"
                                    key={index}
                                  >
                                    <a
                                      href={
                                        typeof window !== "undefined" &&
                                          cookieMsisdn === null
                                          ? `/landing?returnUrl=${data.type == 2 || data.type == 3
                                            ? "/course_detail?courseId=" +
                                            data.courseId +
                                            "&chapterId=" +
                                            data.chapterId
                                            : data.type == 4
                                              ? "/course_detail?courseId=" +
                                              data.courseId +
                                              "&chapterId=" +
                                              data.chapterId +
                                              "&courseVideoId=" +
                                              data.videoId
                                              : "/course_detail?courseId=" +
                                              data.courseId +
                                              "&videoId=" +
                                              data.videoId
                                          }`
                                          : `${data.type == 2 || data.type == 3
                                            ? "/course_detail?courseId=" +
                                            data.courseId +
                                            "&chapterId=" +
                                            data.chapterId
                                            : data.type == 4
                                              ? "/course_detail?courseId=" +
                                              data.courseId +
                                              "&chapterId=" +
                                              data.chapterId +
                                              "&courseVideoId=" +
                                              data.videoId
                                              : "/course_detail?courseId=" +
                                              data.courseId +
                                              "&videoId=" +
                                              data.videoId
                                          }`
                                      }
                                      className="list-group-item list-group-item-action "
                                      aria-current="true"
                                    >
                                      <div className="d-flex w-100 justify-content-between">
                                        <p className="font-13 mb-1 text-red text-truncate text-break">
                                          {data.courseName}
                                        </p>
                                      </div>
                                      <div className="d-flex w-100 justify-content-between">
                                        <p className="font-13 my-1 text-truncate text-break">
                                          {data.title}
                                        </p>
                                      </div>

                                      <div className="d-flex w-100 justify-content-between">
                                        <p className="font-13 my-1">
                                          {data.type === 2 ||
                                            data.type === 3 ||
                                            (data.type === 4 &&
                                              data.chapterName)}
                                        </p>
                                      </div>
                                    </a>
                                  </div>
                                );
                              },
                            )}
                        </div>
                      )}
                    </div>
                  )}

                  <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center">
                    <li
                      className={`nav-item  ${typeof window !== "undefined" &&
                        _location.pathname === "/home"
                        ? " active"
                        : ""
                        }`}
                    >
                      <a
                        className="nav-link cursor-pointer"
                        onClick={() => {
                          setStickyClass("");
                          $(".navbar-collapse").removeClass("show");
                          navigate("/home");
                          hideMenu();
                        }}
                        aria-label="Toggle navigation"
                        onMouseEnter={hideDropDown}
                      >
                        HOME
                      </a>
                    </li>

                    {/* <li
                      className={`nav-item  ${
                        typeof window !== "undefined" &&
                        _location.pathname === "/livequran"
                          ? " active"
                          : ""
                      }`}
                    >
                      <a
                        className="nav-link cursor-pointer"
                        onClick={() => {
                          setStickyClass("");
                          $(".navbar-collapse").removeClass("show");
                          navigate("/livequran");
                          hideMenu();
                        }}
                        aria-label="Toggle navigation"
                        onMouseEnter={hideDropDown}
                      >
                        <>
                          {checkClass ? (
                            <FontAwesomeIcon
                              style={{
                                color: "green",
                                height: "8px",
                                width: "8px",
                                marginBottom: "3px",
                              }}
                              icon={solid("circle")}
                            />
                          ) : null}
                          <span
                            style={{ marginLeft: checkClass ? "5px" : "0px" }}
                          >
                            LIVE CLASSES
                          </span>
                        </>
                      </a>
                    </li> */}
                    <li
                      className={`nav-item   courses-li ${(typeof window !== "undefined" &&
                        _location.pathname.includes("/courses")) ||
                        _location.pathname.includes(UrlNames.satCourse) ||
                        _location.pathname.includes(UrlNames.chapters) ||
                        _location.pathname.includes(UrlNames.topics) ||
                        _location.pathname.includes(UrlNames.content) ||
                        _location.pathname.includes(UrlNames.bookMark)
                        ? " active"
                        : ""
                        }`}
                      onClick={showDropdown}
                      onMouseEnter={showDropdown}
                      id="navbarDropdownMenuLink"
                    >
                      <a
                        href={
                          grades && grades.length > 0
                            ? "/courses?id=" + grades[0].id + "&category=-1"
                            : ""
                        }
                        className="nav-link cursor-pointer d-none d-md-block "
                      >
                        COURSES
                      </a>
                      <a
                        href={
                          grades && grades.length > 0
                            ? "/courses?id=" + grades[0].id + "&category=-1"
                            : ""
                        }
                        className="nav-link d-block d-md-none "
                      >
                        COURSES
                      </a>

                      <div
                        className="d-none d-md-block"
                        onMouseLeave={hideDropDown}
                      >
                        <div
                          className="dropdown-menu px-4  mt-1 pt-0"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                          id="course_menu"
                          aria-labelledby="navbarDropdownMenuLink"
                        >
                          <TabView
                            activeIndex={activeIndex}
                            onTabChange={(e: any) =>
                              handleChange(e.originalEvent, e)
                            }
                          >
                            <TabPanel header="Grades">
                              <div className="row gx-0">
                                {grades &&
                                  (grades || []).map(
                                    (data: any, index: number) => {
                                      return (
                                        <div
                                          className="col-4"
                                          key={data.id}
                                          onClick={() => handleCoursesEvent()}
                                        >
                                          <a
                                            href={
                                              "/courses?grade=" +
                                              data.id +
                                              "&category=-1"
                                            }
                                            className="link-dark"
                                          >
                                            {data.title}
                                          </a>
                                        </div>
                                      );
                                    },
                                  )}
                              </div>
                            </TabPanel>

                            {categories &&
                              categories.map((item: any) => {
                                return (
                                  <TabPanel key={item.id} header={item.title}>
                                    <div className="row gx-0">
                                      {item.courses &&
                                        item.courses.map(
                                          (data: any, index: number) => {
                                            return (
                                              <div
                                                className="col-4"
                                                key={data.id}
                                                onClick={() =>
                                                  handleLanguageEvent(
                                                    data.title,
                                                  )
                                                }
                                              >
                                                <a
                                                  href={
                                                    "/courses?id=" +
                                                    data.id +
                                                    "&category=" +
                                                    item.id
                                                  }
                                                  className="link-dark"
                                                >
                                                  {data.title}
                                                </a>
                                              </div>
                                            );
                                          },
                                        )}
                                    </div>
                                  </TabPanel>
                                );
                              })}
                            <TabPanel
                              header="Test Preparation"
                              // @ts-ignore
                              style={{ cursor: "pointer" }}
                            >
                              <div className="row gx-0">
                                {satCourseData &&
                                  satCourseData?.map(
                                    (data: any, index: number) => {
                                      return (
                                        <div className="col-4" key={data.id}>
                                          <a
                                            href={UrlNames.chapters}
                                            className="link-dark"
                                          >
                                            {data.title}
                                          </a>
                                        </div>
                                      );
                                    },
                                  )}
                              </div>
                            </TabPanel>
                          </TabView>
                        </div>
                      </div>
                    </li>
                    <li
                      className={`nav-item   ${typeof window !== "undefined" &&
                        _location.pathname === "/tips"
                        ? " active"
                        : ""
                        }`}
                    >
                      <a
                        className="nav-link cursor-pointer"
                        onClick={() => {
                          setStickyClass("");
                          navigate("/tips");
                          $(".navbar-collapse").removeClass("show");
                          hideMenu();
                          tagManagerEvents("Exams_Tips & Tricks", utm_source);
                        }}
                        onMouseEnter={hideDropDown}
                      >
                        TIPS & TRICKS
                      </a>
                    </li>
                    <li
                      className={`nav-item   ${typeof window !== "undefined" &&
                        _location.pathname === "/favourite"
                        ? " active"
                        : ""
                        }`}
                    >
                      <a
                        className="nav-link cursor-pointer"
                        onClick={() => {
                          setStickyClass("");
                          navigate("/favourite");
                          tagManagerEvents("Favourites", utm_source);
                          hideMenu();
                          $(".navbar-collapse").removeClass("show");
                        }}
                        onMouseEnter={hideDropDown}
                      >
                        FAVOURITES
                      </a>
                    </li>

                    <li
                      className={`nav-item   ${typeof window !== "undefined" &&
                        _location.pathname === "/editprofile"
                        ? " active"
                        : ""
                        }`}
                    >
                      <a
                        className="nav-link cursor-pointer"
                        onClick={() => {
                          setStickyClass("");
                          navigate("/editprofile");
                          tagManagerEvents("Profile", utm_source);
                          hideMenu();
                          $(".navbar-collapse").removeClass("show");
                        }}
                        onMouseEnter={hideDropDown}
                      >
                        PROFILE
                      </a>
                    </li>
                    <li className="d-none d-lg-block ms-3">
                      <button
                        type="button"
                        className="header_unsub_btn"
                        onClick={handleUnsubscribeClick}
                      >
                        Unsubscribe
                      </button>
                    </li>
                    {typeof window !== "undefined" && cookieMsisdn ? (
                      <>
                        {/* <li className="nav-item d-block d-lg-none">
                          <a
                            className="nav-link cursor-pointer"
                            onClick={unSub}
                          >
                            Unsubscribe
                          </a>
                        </li> */}
                        <li className="nav-item  d-block d-lg-none">
                          <a
                            className="nav-link cursor-pointer"
                            onClick={logout}
                          >
                            Logout
                          </a>
                        </li>
                      </>
                    ) : (
                      <li className="nav-item d-block d-lg-none">
                        <a href="/landing" className="nav-link ">
                          Subscribe
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </>
      )}
      {typeof window !== "undefined" && (
        <GoogleReCaptchaProvider reCaptchaKey={Config.recaptchaSiteKey}>
          <UnsubscribePopup
            show={showUnsub === "unsub"}
            value={msisdn}
            onChange={onChange}
            onConfirmText="Unsubscribe"
            onConfirm={async (flag, recaptchaTokenParam) => {
              console.log("recaptchaToken", recaptchaTokenParam);
              recaptchaToken = recaptchaTokenParam ?? "";
              setShowUnsub(flag ? "confirm" : "none");
            }}
            onCancel={() => setShowUnsub("none")}
            onCancelText="Cancel"
          />
          <AlertModal
            show={showUnsub === "confirm"}
            variant="confirm"
            title="Unsubscribe"
            message="Are you sure you want to unsubscribe?"
            onConfirmText="Unsubscribe"
            onConfirm={() => {
              if (cookieMsisdn) {
                unSub();
              } else {
                unsubGuestUser();
              }
            }}
            isLoading={isLoading}
            onCancel={() => setShowUnsub("none")}
            onCancelText="Cancel"
          />
          <AlertModal
            title="Unsubscribe"
            message={error}
            show={showUnsub === "fail"}
            onConfirmText="Ok"
            onConfirm={() => setShowUnsub("none")}
          />
          <AlertModal
            variant="success"
            title="Congratulations"
            message="You've successfully unsubscribed"
            show={showUnsub === "success"}
            onConfirmText="Ok"
            onConfirm={() => setShowUnsub("none")}
          />
        </GoogleReCaptchaProvider>
      )}
    </>
  );
}
